import { notDefined } from '@vy/null';
import type { CommitmentVsUsage } from '@vy/types';
import { useMemo } from 'react';
import type { FilterLineType } from '../../../../components/new-design/vyTableFilter';
import { applyCommitmentVsUsageFilters } from '../utils/apply-commitment-vs-usage-filters';
import { applyCommitmentVsUsageSearch } from '../utils/apply-commitment-vs-usage-search';

export function useFilteredCommitmentVsUsage(
  report: CommitmentVsUsage | undefined,
  filters: FilterLineType[],
  searchText: string | null | undefined,
): CommitmentVsUsage | undefined {
  return useMemo(() => {
    if (notDefined(report)) {
      return undefined;
    }

    const afterFilters = applyCommitmentVsUsageFilters(report.reportItems, filters);
    const afterSearch = applyCommitmentVsUsageSearch(afterFilters, searchText);

    return { ...report, reportItems: afterSearch };
  }, [report, filters, searchText]);
}
